import { render, staticRenderFns } from "./Inscricoes.vue?vue&type=template&id=c5c47d14&"
import script from "./Inscricoes.vue?vue&type=script&lang=js&"
export * from "./Inscricoes.vue?vue&type=script&lang=js&"
import style0 from "./Inscricoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports